export default {
    '2b-diagram6': {
        'diagram-task': 'Identify the question that the main point raises, and the grouped ideas answer.',
        'checkboxes': {
            'title': 'Question:',
            'checkbox-1': 'How?',
            'checkbox-2': 'Why?',
            'checkbox-3': 'How know?'
        },
        'elements': {
            'one': 'Chickens communicate well-thought-out messages ',
            'two': 'Convey specific information',
            'three': 'Tailor it to the audience',
            'four': 'Reflect the significance of events',
        }
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/2/2b/diagram6/i18n/en.js